import React from 'react';
import { View, Text } from 'react-native';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
export const Counter = ({ value, style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Text, { style: styles.value }, value > 9 ? '9+' : value)));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        width: size.G,
        height: size.G,
        borderRadius: 9999,
        backgroundColor: color.primary.solid,
        alignItems: 'center',
        justifyContent: 'center'
    },
    value: {
        color: color.white.p100,
        fontSize: 11,
        lineHeight: 13,
        letterSpacing: -0.01,
        fontWeight: '600'
    }
}));
//# sourceMappingURL=index.js.map